__turbopack_context__.v({
  "container": "KigCIG_container",
  "pageWrapper": "KigCIG_pageWrapper",
});
